import React, { useEffect, useState } from "react";
import cancelIcon from "../../../assets/images/cancel.png";
import { useLockBodyScroll } from "../../../hooks/useLockBodyScroll";

const UnlockNowModal = ({
  isOpen,
  onClose,
  residentId,
  qrCode_img_src,
  otp_req,
}) => {
  const [qrLink, setQrLink] = useState("");
  const [otp, setOtp] = useState("");

  useEffect(() => {
    if (isOpen) {
      // Single console log for debugging
      console.log("UnlockNowModal data:", {
        qrCode: qrCode_img_src,
        otp: otp_req,
      });

      setQrLink(qrCode_img_src || "");
      setOtp(String(otp_req || ""));
    }
  }, [isOpen, qrCode_img_src, otp_req]);

  useLockBodyScroll(isOpen);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl p-6 w-[90%] max-w-xs relative text-center shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}

        <div className="relative mb-4">
          <h2 className="text-lg font-semibold text-center">Tap To Unlock</h2>
          <img
            src={cancelIcon}
            alt="Close"
            onClick={onClose}
            className="absolute right-1 top-1 w-6 h-6 cursor-pointer hover:scale-110 transition"
          />
        </div>

        <p className="text-sm font-medium text-gray-600 mb-4">
          Scan Or Enter otp <br /> To Collect Your Parcel
        </p>

        {/* QR Code */}
        <div className="flex justify-center mb-2">
          <div className="bg-white p-3 rounded-xl shadow-lg ring-1 ring-gray-200">
            {qrLink ? (
              <img
                src={qrLink}
                alt="QR Code for parcel collection"
                className="w-full h-auto"
              />
            ) : (
              <div className="w-50 h-50 flex items-center justify-center text-gray-400">
                QR Code not available
              </div>
            )}
          </div>
        </div>

        <p className="text-sm font-semibold text-gray-600 mb-4">OR</p>

        {/* OTP Boxes */}
        <div className="flex justify-center gap-2">
          {otp.split("").map((digit, idx) => (
            <div
              key={`otp-${idx}`}
              className="w-10 h-10 border border-gray-300 rounded-lg flex items-center justify-center text-lg font-semibold bg-white"
            >
              {digit}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UnlockNowModal;
